/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class NotificationReportRequest {
    getFixupPrototypeFunction() { return NotificationReportRequest.fixupPrototype; }

    static newInstance(model: Partial<NotificationReportRequest>): NotificationReportRequest {
        let obj = Object.assign(new NotificationReportRequest(), model);
        NotificationReportRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<NotificationReportRequest>): NotificationReportRequest {
        if (!model) return null;
        return NotificationReportRequest.newInstance(<NotificationReportRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: NotificationReportRequest) {
        if (!obj) return;

        models.NotificationReportRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: NotificationReportRequest): boolean {
        Object.setPrototypeOf(obj, NotificationReportRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.email_details) {
            models.NotificationReportEmailDetails.fixupPrototype(this.email_details);
        }
    }

    /**
     * Use default SMTP config when true
     */
    smtp_default: boolean;

    /**
     * Master Account ID for org-level SMTP/template override
     */
    master_account_id: string;

    /**
     * Name of the report being shared (used in audit log)
     */
    report_name: string;

    /**
     * Email addressing and content
     */
    email_details: models.NotificationReportEmailDetails;

}
